<!-- <view-job
(closeJob)="toggleJobMenu()"
[job]="selectedJob"
  [ngClass]="{
    'hidden': isJobMenuHidden
  }">
</view-job> -->

<div [formGroup]="form">
  <!-- <div
  class="menu-filter"
    [ngClass]="{
      hidden: isFilterMenuHidden
    }"
  >
  <div class="menu-filter-close" (click)="toggleFilterMenu()">
    <icon name="close"></icon>
  </div>
  <div class="menu-filter-container">
    <mat-form-field class="filter-option" appearance="fill" >
      <select matNativeControl formControlName="datePosted">
        <option
          *ngFor="let datePostedOption of dates"
          [value]="datePostedOption"
          >
          {{ datePostedOption }}
        </option>
      </select>
    </mat-form-field>
    <mat-form-field class="filter-option" appearance="fill" >
      <mat-select formControlName="industries" multiple>
        <mat-select-trigger>
          <ng-container *ngIf="(form.get('industries')?.value?.length || 0) === 0; else industriesChips">
            <span class="placeholder">Functiegebieden</span>
          </ng-container>
          <ng-template #industriesChips>
            <span class="pill" *ngFor="let v of (form.get('industries')?.value || [])">{{ v }}</span>
          </ng-template>
        </mat-select-trigger>
        <mat-option
          *ngFor="let industryOption of industryOptions"
          [value]="industryOption"
          >
          {{ industryOption }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="filter-option" appearance="fill" >
      <select matNativeControl formControlName="education">
        <option
          *ngFor="let educationalLevel of educationalLevels"
          [value]="educationalLevel"
          >
          {{ educationalLevel }}
        </option>
      </select>
    </mat-form-field>
    <mat-form-field class="filter-option" appearance="fill" >
      <select matNativeControl formControlName="salary">
        <option *ngFor="let salaryType of salaryTypes" [value]="salaryType">
          {{ salaryType }}
        </option>
      </select>
    </mat-form-field>
    <mat-form-field class="filter-option" appearance="fill" >
      <select matNativeControl formControlName="employment">
        <option
          *ngFor="let employmentType of employmentTypes"
          [value]="employmentType"
          >
          {{ employmentType }}
        </option>
      </select>
    </mat-form-field>
    <mat-form-field class="filter-option" appearance="fill" >
      <mat-select formControlName="hours" multiple>
        <mat-select-trigger>
          <ng-container *ngIf="(form.get('hours')?.value?.length || 0) === 0; else hoursChips">
            <span class="placeholder">Uren</span>
          </ng-container>
          <ng-template #hoursChips>
            <span class="pill" *ngFor="let v of (form.get('hours')?.value || [])">{{ v }}</span>
          </ng-template>
        </mat-select-trigger>
        <mat-option *ngFor="let hourType of hourTypes" [value]="hourType">
          {{ hourType }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <div class="update-button">
      <button class="apple-cta apple-cta--blue" (click)="toggleFilterMenu()">
        <span>Update filter</span>
        <icon name="done"></icon>
      </button>
    </div>
  </div>
</div> -->

<div class="search-vacancy">
  <app-breadcrumbs></app-breadcrumbs>
  <div class="top-container">
    <div class="search-container">
      <div class="search-text">Voor professionals</div>
      <div class="search-box">
        <app-search-box [form]="form" (submit)="search()"></app-search-box>
        @if (searchHistory.length > 0) {
          <div class="history">
            <div class="history-text">Recente zoekopdrachten</div>
            <div class="history-chips">
              @for (word of searchHistory; track word) {
                <button
                  class="chip"
                  (click)="setProfession(word)"
                  >
                  <span class="chip-text">{{ word }}</span>
                </button>
              }
              <!-- <button class="chip clear" (click)="clearProfession()">
              <span class="chip-text">Wissen</span>
            </button> -->
          </div>
        </div>
      }
    </div>
  </div>
</div>
<!-- Decorative hero orbs and wave -->
<svg
  class="hero-orb orb-a"
  viewBox="0 0 400 400"
  aria-hidden="true"
  focusable="false"
  >
  <defs>
    <radialGradient id="vacOrbGradientA" cx="50%" cy="50%" r="50%">
      <stop offset="0%" stop-color="#75b6e7" stop-opacity="0.6" />
      <stop offset="100%" stop-color="#75b6e7" stop-opacity="0" />
    </radialGradient>
  </defs>
  <circle cx="200" cy="200" r="200" fill="url(#vacOrbGradientA)" />
</svg>
<svg
  class="hero-orb orb-b"
  viewBox="0 0 400 400"
  aria-hidden="true"
  focusable="false"
  >
  <defs>
    <radialGradient id="vacOrbGradientB" cx="50%" cy="50%" r="50%">
      <stop offset="0%" stop-color="#ffffff" stop-opacity="0.35" />
      <stop offset="100%" stop-color="#ffffff" stop-opacity="0" />
    </radialGradient>
  </defs>
  <circle cx="200" cy="200" r="200" fill="url(#vacOrbGradientB)" />
</svg>
<svg
  class="hero-wave"
  viewBox="0 0 1440 120"
  preserveAspectRatio="none"
  aria-hidden="true"
  focusable="false"
  >
  <path
    d="M0,40 C240,100 480,0 720,40 C960,80 1200,20 1440,60 L1440,120 L0,120 Z"
    fill="#f6f6f6"
  ></path>
</svg>
</div>

@if (false && isMobile) {
  <div class="filter-mobile">
    <div class="filter-header">
      <div class="filter-text">Filters</div>
      <div class="clear-filter-button">
        <button
          class="apple-cta apple-cta--blue apple-cta--small"
          (click)="clearAll()"
          >
          <span>Alles wissen</span>
          <icon name="close"></icon>
        </button>
      </div>
    </div>
    <div class="filter-mobile-options">
      <div
        class="filter-mobile-settings"
        [ngClass]="{ toggled: !isFilterMenuHidden }"
        (click)="toggleFilterMenu()"
        >
        <icon name="tune"></icon>
      </div>
      <mat-form-field
        class="filter-option"
        appearance="fill"
        >
        <select
          matNativeControl
          formControlName="datePosted"
          placeholder="Datum geplaatst"
          >
          @for (datePostedOption of dates; track datePostedOption) {
            <option
              [value]="datePostedOption"
              >
              {{ datePostedOption }}
            </option>
          }
        </select>
      </mat-form-field>
      <mat-form-field
        class="filter-option"
        appearance="fill"
        >
        <mat-select
          formControlName="industries"
          multiple
          placeholder="Functiegebieden"
          >
          <mat-select-trigger>
            @if (
              (form.get('industries')?.value?.length || 0) === 0) {
              <span class="placeholder">Functiegebieden</span>
            } @else {
              @for (v of form.get('industries')?.value || []; track v) {
                <span
                  class="pill"
                  >{{ v }}</span
                  >
                }
              }
            </mat-select-trigger>
            @for (industryOption of industryOptions; track industryOption) {
              <mat-option
                [value]="industryOption"
                >
                {{ industryOption }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field
          class="filter-option"
          appearance="fill"
          >
          <select
            matNativeControl
            formControlName="education"
            placeholder="Opleidingsniveau"
            >
            @for (educationalLevel of educationalLevels; track educationalLevel) {
              <option
                [value]="educationalLevel"
                >
                {{ educationalLevel }}
              </option>
            }
          </select>
        </mat-form-field>
        <mat-form-field
          class="filter-option"
          appearance="fill"
          >
          <select
            matNativeControl
            formControlName="salary"
            placeholder="Minimum salaris"
            >
            @for (salaryType of salaryTypes; track salaryType) {
              <option [value]="salaryType">
                {{ salaryType }}
              </option>
            }
          </select>
        </mat-form-field>
        <mat-form-field
          class="filter-option"
          appearance="fill"
          >
          <select
            matNativeControl
            formControlName="employment"
            placeholder="Dienstverband"
            >
            @for (employmentType of employmentTypes; track employmentType) {
              <option
                [value]="employmentType"
                >
                {{ employmentType }}
              </option>
            }
          </select>
        </mat-form-field>
        <mat-form-field
          class="filter-option"
          appearance="fill"
          >
          <mat-select formControlName="hours" multiple placeholder="Uren">
            <mat-select-trigger>
              @if (
                (form.get('hours')?.value?.length || 0) === 0) {
                <span class="placeholder">Uren</span>
              } @else {
                @for (v of form.get('hours')?.value || []; track v) {
                  <span
                    class="pill"
                    >{{ v }}</span
                    >
                  }
                }
              </mat-select-trigger>
              @for (hourType of hourTypes; track hourType) {
                <mat-option [value]="hourType">
                  {{ hourType }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    }

    <div #filterRef class="container">
      <div class="filter">
        <div class="filter-header">
          <div class="filter-text">Filters</div>
          <button
            class="filter-clear-chip"
            (click)="clearAll()"
            >
            <span>Alles wissen</span>
            <icon name="close"></icon>
          </button>
        </div>
        <div class="filter-options">
          <apple-multiselect
            [multiple]="false"
            formControlName="datePosted"
            [options]="dates"
            placeholder="Datum geplaatst">
          </apple-multiselect>

          <apple-multiselect
            formControlName="industries"
            [options]="industryOptions"
            placeholder="Functiegebieden">
          </apple-multiselect>

          <apple-multiselect
            [multiple]="false"
            formControlName="education"
            [options]="educationalLevels"
            placeholder="Opleidingsniveau">
          </apple-multiselect>

          <apple-multiselect
            [multiple]="false"
            formControlName="salary"
            [options]="salaryTypes"
            placeholder="Minimum salaris">
          </apple-multiselect>

          <apple-multiselect
            [multiple]="false"
            formControlName="employment"
            [options]="employmentTypes"
            placeholder="Dienstverband">
          </apple-multiselect>

          <apple-multiselect
            formControlName="hours"
            [options]="hourTypes"
            placeholder="Uren">
          </apple-multiselect>
        </div>
      </div>
    </div>
    <div class="container">
      @if (isLoadingJobs) {
        <div class="vacancies">
          @for (i of pageSizeNgFor; track i) {
            <div class="vacancy">
              <div class="job-description-header-skeleton skeleton-box"></div>
              <div class="margin-skeleton"></div>
              <div class="vacancy-filter-container">
                <div class="vacancy-filter-left">
                  <div class="vacancy-filter-row">
                    <div
                      class="job-description-bullet-skeleton skeleton-box"
                      style="width: 20px; height: 20px"
                    ></div>
                    <div class="vacancy-filter-row-container">
                      <span class="vacancy-type-skeleton skeleton-box"></span>
                      <div class="margin-small-skeleton"></div>
                      <span class="vacancy-type-skeleton skeleton-box"></span>
                    </div>
                  </div>
                  <div class="vacancy-filter-row">
                    <div
                      class="job-description-bullet-skeleton skeleton-box"
                      style="width: 20px; height: 20px"
                    ></div>
                    <div class="vacancy-filter-row-container">
                      <span class="vacancy-type-skeleton skeleton-box"></span>
                      <div class="margin-small-skeleton"></div>
                      <span class="vacancy-type-skeleton skeleton-box"></span>
                    </div>
                  </div>
                  <div class="vacancy-filter-row">
                    <div
                      class="job-description-bullet-skeleton skeleton-box"
                      style="width: 20px; height: 20px"
                    ></div>
                    <div class="vacancy-filter-row-container">
                      <span class="vacancy-type-skeleton skeleton-box"></span>
                      <div class="margin-small-skeleton"></div>
                      <span class="vacancy-type-skeleton skeleton-box"></span>
                    </div>
                  </div>
                </div>
                <div class="vacancy-filter-right">
                  <div class="vacancy-filter-row">
                    <div
                      class="job-description-bullet-skeleton skeleton-box"
                      style="width: 20px; height: 20px"
                    ></div>
                    <div class="vacancy-filter-row-container">
                      <span class="vacancy-type-skeleton skeleton-box"></span>
                      <div class="margin-small-skeleton"></div>
                      <span class="vacancy-type-skeleton skeleton-box"></span>
                    </div>
                  </div>
                  <div class="vacancy-filter-row">
                    <div
                      class="job-description-bullet-skeleton skeleton-box"
                      style="width: 20px; height: 20px"
                    ></div>
                    <div class="vacancy-filter-row-container">
                      <span class="vacancy-type-skeleton skeleton-box"></span>
                      <div class="margin-small-skeleton"></div>
                      <span class="vacancy-type-skeleton skeleton-box"></span>
                    </div>
                  </div>
                  <div class="vacancy-filter-row">
                    <div
                      class="job-description-bullet-skeleton skeleton-box"
                      style="width: 20px; height: 20px"
                    ></div>
                    <div class="vacancy-filter-row-container">
                      <span class="vacancy-type-skeleton skeleton-box"></span>
                      <div class="margin-small-skeleton"></div>
                      <span class="vacancy-type-skeleton skeleton-box"></span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="vacancy-description">
                <div class="job-description-paragraph-skeleton skeleton-box"></div>
                <div class="margin-small-skeleton"></div>
                <div
                  class="job-description-paragraph-skeleton skeleton-box"
                  style="width: 60%"
                ></div>
                <div class="margin-small-skeleton"></div>
                <div class="vacancy-button">
                  <div class="vacancy-apply-button-skeleton skeleton-box"></div>
                </div>
              </div>
              <div class="vacancy-time">
                <div
                  class="job-description-paragraph-skeleton skeleton-box"
                  style="width: 20%"
                ></div>
              </div>
            </div>
          }
        </div>
      }

      @if (!isLoadingJobs) {
        <div class="vacancies">
          @for (vacancy of displayedJobsCatsOne; track vacancy) {
            <div
              #vacanciesRef
              class="vacancy apple-card"
              >
              <div class="vacancy-header">{{ vacancy.title }}</div>
              <div class="vacancy-filter-container">
                <div class="vacancy-filter-left">
                  <div class="vacancy-filter-row">
                    <icon name="location_on_filled"></icon>
                    <div class="vacancy-filter-row-container">
                      <span>Locatie</span>
                      <span class="vacancy-type">{{ vacancy.location.city }}</span>
                    </div>
                  </div>
                  <div class="vacancy-filter-row">
                    <icon name="business"></icon>
                    <div class="vacancy-filter-row-container">
                      <span>Functiegebieden</span>
                      <div class="vacancy-type">{{ mapIndustries(vacancy) }}</div>
                    </div>
                  </div>
                  <div class="vacancy-filter-row">
                    <icon name="school_filled"></icon>
                    <div class="vacancy-filter-row-container">
                      <span>Opleidingsniveau</span>
                      <span class="vacancy-type">{{ educationOrNA(vacancy) }}</span>
                    </div>
                  </div>
                </div>
                <div class="vacancy-filter-right">
                  <div class="vacancy-filter-row">
                    <icon name="euro"></icon>
                    <div class="vacancy-filter-row-container">
                      <span>Salaris</span>
                      <span class="vacancy-type">{{
                        parseSalary(vacancy.salary)
                      }}</span>
                    </div>
                  </div>
                  <div class="vacancy-filter-row">
                    <icon name="schedule_filled"></icon>
                    <div class="vacancy-filter-row-container">
                      <span>Dienstverband</span>
                      <span class="vacancy-type">{{ employmentOrNA(vacancy) }}</span>
                    </div>
                  </div>
                  <div class="vacancy-filter-row">
                    <icon name="hourglass_filled"></icon>
                    <div class="vacancy-filter-row-container">
                      <span>Uren</span>
                      <span class="vacancy-type">{{ parseHours(vacancy) }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="vacancy-description">
                @if (vacancy.shortDescription) {
                  <span
                    class="vacancy-text"
                    [innerHTML]="vacancy.shortDescription"
                  ></span>
                }
                <div class="vacancy-button">
                  <button
                    class="apple-cta apple-cta--blue"
                    (click)="viewJob($event, vacancy)"
                    >
                    <span>Bekijk vacature</span>
                    <icon name="navigate_next"></icon>
                  </button>
                </div>
              </div>
              <div class="vacancy-time">
                Geplaatst: {{ dateToDatePosted(vacancy.publicationDate) }}
              </div>
              <!-- <div class="vacancy-time">Laatst geupdate: {{dateToDatePosted(vacancy.dateModified)}}</div> -->
            </div>
          }
          @if (noResultsFound) {
            <div>
              <div class="no-results">
                <div class="no-results-header">
                  <icon name="search_off"></icon>
                  <div>We hebben geen relevante resultaten kunnen vinden.</div>
                </div>
                <div class="no-results-button">
                  <button
                    class="apple-cta apple-cta--blue"
                    (click)="clearAll()"
                    >
                    <span>Verwijder zoekopdracht</span>
                    <icon name="close"></icon>
                  </button>
                </div>
              </div>
            </div>
          }
          @if (!noResultsFound) {
            <div #paginatorRef class="paginator scroll-fade">
              <apple-paginator
                [length]="length"
                [pageSize]="pageSize"
                [pageIndex]="pageIndex"
                [pageSizeOptions]="pageSizeOptions"
                (page)="pageChange($event)"
                >
              </apple-paginator>
            </div>
          }
          <div #jobNotFoundRef class="job-not-found scroll-fade">
            <div class="job-not-found-title">Nog niet klaar om te solliciteren? Stel jezelf voor!</div>
            <div class="job-not-found-text">
              Zie je op dit moment geen rol die direct bij jouw vaardigheden en interesses past? Geen probleem. Via <span class="link" (click)="apply($event)"><icon name="account_circle"></icon>Stel jezelf voor</span> kun je eenvoudig je gegevens achterlaten. Wij kijken vervolgens persoonlijk met je mee welke mogelijkheden het beste bij jou aansluiten, nu of in de toekomst.
            </div>
            <div class="vacancy-button">
              <button
                class="apple-cta apple-cta--blue"
                (click)="apply($event)"
                >
                <span>Stel jezelf voor</span>
                <icon name="navigate_next"></icon>
              </button>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
